import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

import { SharedModule } from '../shared/shared.module';
import { AuthenticationContainerComponent } from './containers/authentication-container/authentication-container.component';
import { UpdatePasswordContainerComponent } from './containers/update-password-container/update-password-container.component';
import { MfaauthenticationContainerComponent } from '../authentication/containers/mfaauthentication-container/mfaauthentication-container.component';

import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { MfaLoginComponent } from './components/mfa-login/mfa-login.component';
import { MfaAuthSelectorComponent } from './components/mfa-auth-selector/mfa-auth-selector.component';

import { EffectsModule } from '@ngrx/effects';
import { AuthenticationEffects } from './effects/authentication.effect';

import {AuthenticationService} from './services/authentication.service';
import { WrapperLayoutComponent } from './components/wrapper-layout/wrapper-layout.component';
import { StaticTextComponent } from './components/static-text/static-text.component';
import { MultipleOffersComponent } from './components/multiple-offers/multiple-offers.component';

@NgModule({
  imports: [
    FormsModule,
    TextMaskModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    HttpModule,
    SharedModule,
    EffectsModule.run(AuthenticationEffects)
  ],
  declarations: [
    AuthenticationContainerComponent,
    UpdatePasswordContainerComponent,
    LoginComponent,
    ResetPasswordComponent,
    UpdatePasswordContainerComponent,
    UpdatePasswordComponent,
    WrapperLayoutComponent,
    StaticTextComponent,
    MultipleOffersComponent,
    MfaauthenticationContainerComponent,
    MfaLoginComponent,
    MfaAuthSelectorComponent
  ],
  exports: [ AuthenticationContainerComponent, UpdatePasswordContainerComponent, MfaauthenticationContainerComponent ],
  providers: [AuthenticationService]
})
export class AuthenticationModule { }



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts